import { Column, Entity } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('m_ringcentral_plugin_call_log_token')
export class RingCentralCallLogTokenEntity extends BaseEntity {
	@Column('text', {
		name: 'm_ringcentral_plugin_accessToken',
	})
	public accessToken!: string;

	@Column('text', {
		name: 'm_ringcentral_plugin_refreshToken',
	})
	public refreshToken!: string;

	@Column('varchar', {
		name: 'm_ringcentral_plugin_endpointId',
		length: 255,
	})
	public endpointId!: string;

	@Column({
		type: 'int',
		name: 'm_ringcentral_plugin_userId',
		unsigned: true,
	})
	public userId!: number;
}
